exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-overlay{display:none;background:hsla(0,0%,100%,.7);position:fixed;bottom:0;left:0;right:0;top:0;z-index:9998;align-items:center;justify-content:center}.loading-overlay.is-active{display:flex}", ""]);

// exports
